var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6279 8.12932C28.3008 6.89755 27.3369 5.92745 26.1131 5.59823C23.8949 5 15.0001 5 15.0001 5C15.0001 5 6.10528 5 3.887 5.59823C2.6632 5.9275 1.69934 6.89755 1.37221 8.12932C0.777832 10.362 0.777832 15.0202 0.777832 15.0202C0.777832 15.0202 0.777832 19.6784 1.37221 21.9111C1.69934 23.1429 2.6632 24.0726 3.887 24.4018C6.10528 25 15.0001 25 15.0001 25C15.0001 25 23.8949 25 26.1131 24.4018C27.3369 24.0726 28.3008 23.1429 28.6279 21.9111C29.2223 19.6784 29.2223 15.0202 29.2223 15.0202C29.2223 15.0202 29.2223 10.362 28.6279 8.12932ZM12.091 19.2495V10.7909L19.5253 15.0203L12.091 19.2495Z",
    fill: "#232F3C",
    className: "social-icon"
  })));
};
export default SvgYoutube;